import * as React from 'react';
import { withMetroLine } from 'app/components/metro-line/with-metro-line';
import { WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ExternalUrlSectionType } from '../metroline/types';
import { ExternalUrlFormProps } from '../types';
import { ExternalUrlContainer } from './external-url-container';
import { ExternalUrlDetails } from './external-url-details';
import { ExternalUrlLanguage } from './external-url-language';
import { ExternalUrlVisibility } from 'app/area/external-urls-administration/form/components/external-url-visibility';

const ExternalUrlFormRendererContainer: React.FC<ExternalUrlFormProps
  & WithMetroLineWrappedComponentProps<ExternalUrlSectionType>> = ({
    locale, translation, section, translationAdminAccess, options, shouldPrompt,
    actionType, formState, mainLanguage, showTranslations, switchTranslationsToggle,
    saveExternalUrl, deleteExternalUrl, updateItem,
    changeLanguage, copyLanguageToAll, changeLongDescription, copyLongDescriptionToAll,
    updateExcludedFields, loadOptions, updateValidation, resetValidation, displayError, getRef, shouldRenderSection
  }) => {

    const { externalUrlItem, originalExternalUrlItem, languageOptions, validation } = formState;
    const panelProps = {
      actionType,
      externalUrlItem,
      options,
      locale,
      validation,
      translation,
      section,
      translationAdminAccess,
      getRef,
      shouldRenderSection,
      loadOptions,
      updateExcludedFields,
      updateItem,
      updateValidation,
      resetValidation,
      displayError
    };

    const renderLanguageOnTop = !isDefinedIncludingZero(externalUrlItem?.id);
    const languageSection = <ExternalUrlLanguage
      language={externalUrlItem?.language}
      longDescription={externalUrlItem?.longDescription}
      mainLanguage={mainLanguage}
      languageOptions={languageOptions}
      changeLanguage={changeLanguage}
      copyLanguageToAll={copyLanguageToAll}
      changeLongDescription={changeLongDescription}
      copyLongDescriptionToAll={copyLongDescriptionToAll}
      showTranslations={showTranslations}
      switchTranslationsToggle={switchTranslationsToggle}
      validation={validation}
      translation={translation}
      section={section}
      getRef={getRef}
      shouldRenderSection={shouldRenderSection} />;

    return <ExternalUrlContainer
      actionType={actionType}
      formState={formState}
      shouldPrompt={shouldPrompt}
      mainLanguage={mainLanguage}
      switchTranslationsToggle={switchTranslationsToggle}
      saveExternalUrl={saveExternalUrl}
      deleteExternalUrl={deleteExternalUrl}
      updateValidation={updateValidation}
      displayError={displayError}
      validation={validation}
      translation={translation}>
      {renderLanguageOnTop && languageSection}
      <ExternalUrlDetails {...panelProps} />
      <ExternalUrlVisibility {...panelProps} originalExternalUrlItem={originalExternalUrlItem} />
      {!renderLanguageOnTop && languageSection}
    </ExternalUrlContainer>;
  };

export const ExternalUrlFormRenderer = withMetroLine<ExternalUrlFormProps,
  ExternalUrlSectionType>()(ExternalUrlFormRendererContainer);
